import { Directive } from '@angular/core';
import { CdkMenu } from '@angular/cdk/menu';

/** Wraps CDK `CdkMenu` with `ps-` + Bootstrap panel classes; see `components/dropdown/README.md`. */
@Directive({
  selector: '[psDropdownMenu]',
  standalone: true,
  hostDirectives: [
    {
      directive: CdkMenu,
      outputs: ['closed: psDropdownMenuClosed'],
    },
  ],
  host: {
    class: 'ps-dropdown-menu dropdown-menu show',
    style:
      'position: static; top: auto; right: auto; bottom: auto; left: auto; margin-top: 0; float: none;',
  },
})
export class PsDropdownMenuDirective {}
